<template>
    <div class="w-full overflow-hidden bg-white mt-4 mb-24 font-poppins">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
      <!-- LOADER  -->
      <div
        v-if="loader_company"
        class="fixed inset-0 flex items-center justify-center bg-white z-50"
      >
        <img
          src="@/assets/imgs/tuin_loader_v2.gif"
          alt="cargando..."
          class="w-[500px]"
        >
      </div>
      <!-- LOADER  -->
      <div class="flex justify-between items-center">
        <div class="p-4">
          <div class="flex">
            <div class="text-center text-[22px] md:text-[32px] sm:text-left font-medium">
              Datos de tu Inmobiliaria
            </div>
          </div>
          <div class="mt-4 sm:mt-1">
            <div class="flex flex-col md:flex-row items-start font-normal md:text-sm text-base md:mb-9">
              <span>
                Puedes ver los detalles de tu inmobiliaria haz clic
                <a 
                  :href="`${apiBaseUrl}/inmobiliarias/${slug}`" 
                  class="text-tuin_base-0 underline md:ml-2 mt-1 md:mt-0"
                  target="_blank" 
                  rel="noopener noreferrer">
                  {{ "Ver perfil de la inmobiliaria." }}
                </a>
              </span>
            </div>
          </div>
        </div>
        <div class="hidden" v-if="step !== 0 && slug && slug.length > 0"> 
          <ShareButton 
            :this-url="slug_url"
            :this-name="inputs.name.value"
            :company-id="id"
            :agent-id="id"
            Type="company" 
          />
        </div>
      </div>
      <div class="flex flex-col sm:flex-row mt-4 sm:mt-2">
        <!-- Logo empresa -->
        <div class="w-full sm:w-1/2 mb-4 sm:mb-0">
          <!-- Contenedor principal del logo -->
          <div v-show="!hasImage">
            <div
              :class="[
                'border-4 border-dashed p-6 rounded-md cursor-pointer', // Añadimos 'relative' aquí
                dragging
                  ? 'border-tuin_base-0 bg-white'
                  : 'border-tuin_base-0 bg-white',
              ]"
              class="flex flex-col items-center justify-center space-y-4 p-4 m-4"
              @dragover.prevent
              @dragenter.prevent="dragging = true"
              @dragleave="dragging = false"
              @drop.prevent="handleDrop"
              @click="triggerFileInput"
            >
              <!-- Contenedor de la imagen con posicionamiento relativo -->
              <div class="relative w-full flex justify-center items-center">
                <img
                  id="logo_company"
                  src="@/assets/imgs/upload.svg"
                  alt="Logo de copañía"
                  class="md:w-[44px] md:h-[44px] h-11 w-11"
                >
                <!-- Botón para eliminar 
                <button 
                  v-if="img_src && img_src !== require('@/assets/imgs/inmobi_default.png')"
                  @click.stop="removeImage"
                  class="absolute -top-2 -right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-10"
                  title="Eliminar imagen"
                >
                  ×
                </button>-->
              </div>
  
              <p
                v-if="!is_new"
                class="text-gray-500 justify-center items-center"
              >
                Arrastra aquí el logo de tu inmobiliaria o has clic para subirla
              </p>
              <p
                v-if="is_new"
                class="text-gray-500 justify-center items-center"
              >
                Arrastra aquí el logo de tu inmobiliaria o has clic para subirla
              </p>
              <!-- <ul v-else class="list-disc">
            <li v-for="(file, index) in files" :key="index">
              {{ file.name }}
            </li>
          </ul> -->
          
              <input
                ref="fileInput"
                type="file"
                class="hidden"
                accept="image/*"
                @change="handleFileSelect"
              >
              <button
                class="bg-blue-500 text-white px-4 py-2 rounded hidden"
                @click="triggerFileInput"
              >
                Seleccionar Archivos
              </button>
            </div>
          </div>
          <!-- Preview de la imagen si ya fue cargada -->
          <!--Image New-->
          <div v-show="hasImage" class="relative w-full flex flex-col md:flex-row justify-center md:justify-start items-center p-4 space-y-4 md:space-y-0 md:space-x-8">
            <img
              id="logo_company"
              :src="img_src"
              :key="img_src"
              alt="Logo de compañía"
              width="250"
              height="250"
              class="w-[125px] h-[125px] object-cover rounded-full"
            >
            <div class="flex flex-col space-y-2">
              <button
                class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
                @click="triggerFileInput"
              >
                Cambiar Imagen
              </button>
              <button
                class="bg-custom_gray hover:bg-darkgray text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
                @click.stop="removeImage"
              >
                Eliminar Imagen
              </button>
            </div>
          </div>
          <div class="p-4 flex flex-col space-y-4">
            <div class="flex justify-center items-center">
              <div class="w-full">
                <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Nombre*</label>
                <input
                  type="text"
                  v-model="inputs.name.value"
                  required
                  placeholder="Ingresa el nombre"
                  @blur="validateName"
                  :class="{
                    'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.name,
                    'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.name
                  }"
                />
                <p v-if="errors.name" class="mt-1 text-sm font-medium text-red-600">{{ errors.name }}</p>
              </div>
            </div>

            <div class="flex justify-center items-center">
              <div class="w-full">
                <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Correo*</label>
                <input
                  type="email"
                  v-model="inputs.email.value"
                  required
                  placeholder="Ingresa tu correo"
                  @blur="validateEmail"
                  :class="{
                    'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.email,
                    'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.email
                  }"
                />
                <p v-if="errors.email" class="mt-1 text-sm font-medium text-red-600">{{ errors.email }}</p>
              </div>
            </div>

            <div class="w-full">
              <label
                for="phone"
                class="block mb-2 text-sm font-medium text-custom_gray"
                >Teléfono*</label>
    
                <InputMask
                  id="phone"
                  v-model="inputs.phone.value"
                  mask="99-9999-9999"
                  placeholder="Ingresa el número celular"
                  @blur="validatePhone"
                  :class="{
                  'bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full': !errors.phone,
                  'border-red-500 h-11 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full': errors.phone
                }"
                  fluid
                />
                <p v-if="errors.phone" class="mt-1 text-sm font-medium text-red-600">{{ errors.phone }}</p>
            </div>

            <div class="flex justify-center items-center">
              <div class="w-full">
                <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Sitio Web</label>
                <input
                  type="text"
                  v-model="inputs.website.value"
                  placeholder="Ingresa tu sitio web"
                  @blur="validateWebsite"
                  :class="{
                    'bg-white border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !errors.website,
                    'border border-red-500 bg-red-50 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': errors.website
                  }"
                />
                <p v-if="errors.website" class="mt-1 text-sm font-medium text-red-600">{{ errors.website }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Logo empresa -->
        <div class="w-full sm:w-2/3 mb-4 sm:mb-0 mr-4">
          <!-- Form -->
          <label
            for="phone"
            class="block mb-2 md:text-sm text-base font-medium text-custom_gray px-4 md:px-0"
          >
            ¡Queremos conocerte! Comparte la historia de tu inmobiliaria y los servicios que ofreces.
          </label>
          <div class="p-4 md:p-0">
            <ckeditor
              v-model="description"
              :editor="editor"
              :config="editorConfig"
              class="custom-editor"
            />
          </div>
          <div class="flex flex-col">
            <div class="flex flex-1 justify-end items-end mt-5 p-2">
              <button
                class="bg-tuin-100 hover:bg-tuin_hover text-sm font-medium text-white focus:outline-none focus:ring-transparent px-5 py-2.5 rounded-lg"
                size="xl"
                @click="SaveCompany()"
              >
                Guardar
              </button>
            </div>
          </div>
          <!-- Fin form  -->
        </div>
      </div>
    </div>
  </template>
  <script setup>
  import ToastAlert from "@/commond/ToastAlert.vue";
  import { ref, reactive, watch, computed, onBeforeMount } from "vue";
  import { useStore } from "vuex";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
//  import { FwbInput } from "flowbite-vue";
  import InputMask from "primevue/inputmask";
  import axios from 'axios';
  // import LogoCompanyComponent from "./company/LogoCompanyComponent.vue";
  //import FormDetailComponent from "./company/FormDetailComponent.vue";
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  //let imageSrc = computed(() => store.getters.imgSrc);
  let img_src = ref(require('@/assets/imgs/inmobi_default.png'));
  // Variable para controlar si hay una imagen real o no
  const hasImage = ref(false);
  
  import { useRouter } from "vue-router";
  import ShareButton from "./ShareButton.vue";
  let router = useRouter();
  let toastAlert  = ref(false);
  let typeMsg     = ref("");
  let msg         = ref("");
  let step = ref(0);
  const apiBaseUrl = computed(() => process.env.VUE_APP_API_BASE_URL.replace(/\/api$/, ""));
  let inputs = {
      agent_id:     ref(""),
      name:         ref(""),    
      email:        ref(""),
      phone:        ref(""),
      website:      ref(""),
      img_src:      ref(""),
  };

  // Objeto para manejar los errores de validación
  const errors = reactive({
      name: "",
      email: "",
      phone: "",
      website: ""
  });
  let slug = ref();
  let slug_url = ref();
  let id = ref();
  let description     = ref("");
 
  
  let loader_company = ref(false);
  
  const editor            = ref(ClassicEditor);
  const editorConfig = {
    toolbar: [
      "heading",
      "|",
      "bold",
      "italic",
      "underline",
      "strikethrough",        
      "blockQuote",
      "|",
      "undo",
      "redo",
      "|",
      "numberedList",
      "bulletedList",
      "|",
      "alignment",
      "indent",
      "outdent",
      "|",
      
      "insertHR",
      "code",
      "codeBlock",
      "removeFormat",
    ],
      height: "500px",
  };
  const dragging = ref(false);
  const files = reactive([]);
  //require('@/assets/imgs/inmobi_default.png')
  //const img_src = ref('');
  
  const is_new = ref(false);
  
  const fileInput = ref(null);
  
  const handleDrop = (event) => {
    dragging.value = false;
    const droppedFiles = event.dataTransfer.files;
    handleFiles(droppedFiles);
  };
  
  const handleFileSelect = (event) => {
    const selectedFiles = event.target.files;
    handleFiles(selectedFiles);
  };
  
  const handleFiles = (fileList) => {
    for (let i = 0; i < fileList.length; i++) {
      files.push(fileList[i]);
      convertToBase64(fileList[i]);
    }
  };
  
  const triggerFileInput = () => {
    fileInput.value.click(); // Aquí es donde se corrige la referencia
  };
  const removeImage = () => {
    img_src.value = require('@/assets/imgs/inmobi_default.png');
    hasImage.value = false;
    if (fileInput.value) {
      fileInput.value.value = ''; // Reset file input
    }
  };
  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // Lee el archivo como DataURL (base64)
    reader.onload = () => {
      img_src.value = reader.result; // Asigna el base64 al `src` de la imagen
      hasImage.value = true; // Actualizar estado: hay imagen
      //store.dispatch("setImageSrc", reader.result);
      // Aquí puedes enviar el `reader.result` al backend si lo deseas
      //sendToBackend(reader.result);
    };
    reader.onerror = (error) => {
      console.error("Error al convertir a base64: ", error);
    };
  };
  
  // function retriveLogo(logo_api) {
  //   console.log('[LOGO_WATCH]', logo_api)
  //   img_src.value = logo_api
  //   setTimeout(()=>{
  //     loader_company.value = false;
  //   }, 800)
  // }
  async function SaveCompany(){
      //console.log('enviar guardar ', imageSrc.value)
      let telephone = inputs.phone.value;
      let numeroEntero = telephone.replace(/-/g, '');
  
      let stepValue = slug.value ? 3 : 2;
      //colony:             inputs.colony.value,
  
      let params = {
        agent_id:           session.value.id,
        name:               inputs.name.value,
        email:              inputs.email.value,
        phone:              numeroEntero,
        website:            inputs.website.value,
        step:               stepValue,
        img_src:            img_src.value.split('?')[0],
        description:          description.value
      };
      
      // img_src:            imageSrc.value
      //console.log('ImagenSrc', imageSrc.value)    
      let is_valid = await ValidateForm();
  
      let link_post = `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/actualizar_company`;
      console.log(params)
      if(is_valid.status !== 'error' ){
        let options = {
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${session.value.token_api}`
          }
        }
        
        const response = await axios.post(link_post, params, options);
  
        if (response.status == 200) {
          showToast('success', 'Datos guardados correctamente')        
          if(session.value.step < 3 ){
            session.value.step=2;
            //router.push({ name: "info_networks" });
            router.push({ name: "info_profile" });
          }
        }
        await getInfoCompany();
      }else{
        toastAlert.value  = true;
        typeMsg.value     = "danger";
        msg.value         = is_valid.message;
        setTimeout(()=>{
          closeToast();
        }, 2000);
      } 
  
  }
  
  // Validación individual para el campo nombre
  function validateName() {
    errors.name = "";
    if (inputs.name.value.trim() === '') {
      errors.name = "Campo obligatorio";
      return false;
    }
    return true;
  }

  // Validación individual para el campo email
  function validateEmail() {
    errors.email = "";
    if (inputs.email.value.trim() === '') {
      errors.email = "Campo obligatorio";
      return false;
    } else if (!isValidEmail(inputs.email.value)) {
      errors.email = "El formato del correo no es válido";
      return false;
    }
    return true;
  }

  // Validación individual para el campo teléfono
  function validatePhone() {
    errors.phone = "";
    if (inputs.phone.value.trim() === '') {
      errors.phone = "Campo obligatorio";
      return false;
    }
    return true;
  }

  // Validación individual para el campo website
  function validateWebsite() {
    errors.website = "";
    if (inputs.website.value && !isValidURL(inputs.website.value)) {
      errors.website = "El formato del sitio web no es válido";
      return false;
    }
    return true;
  }

  async function ValidateForm() {
    // Limpiar errores previos
    errors.name = "";
    errors.email = "";
    errors.phone = "";
    errors.website = "";
    
    // Ejecutar todas las validaciones
    const nameValid = validateName();
    const emailValid = validateEmail();
    const phoneValid = validatePhone();
    const websiteValid = validateWebsite();
    
    // Verificar si hay errores
    if (!nameValid || !emailValid || !phoneValid || !websiteValid) {
      return { status: 'error', message: 'Por favor corrige los errores en el formulario' };
    }
    
    return { status: 'success', message: 'Datos Correctos' };
  }
  
  // Función para validar correos electrónicos
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  // Función para validar URLs
  function isValidURL(url) {
    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-.]*)*\/?$/;
    return urlRegex.test(url);
  }
  
  
  async function getInfoCompany(){
    
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
  
    let link_api = `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}/company`;
    const response = await axios.get(
        link_api,
        options
      );
    try {
      if (response.status == 401) {
        store.dispatch("clearUserSession");
        loader_company.value = false;
      }
  
      if (response.status == 200) {
        console.log(response)
        let info = response.data.resp.info;
        
        inputs.agent_id.value       =  session.value.id;
        inputs.name.value          =  info.name;
        inputs.email.value       =  info.email;
        inputs.phone.value          =  info.phone;
        inputs.website.value        =  info.website;
        description.value = info.description || '';
        slug.value = info.slug;
        slug_url.value = info.slug_url;
        id.value = info.id;
        step.value = 2;
        
        console.log('[logo]', info.logo)
        if (info.logo) {
          img_src.value = `${info.logo}?v=${Date.now()}`;
          hasImage.value = true; // Hay imagen real
        } else {
          img_src.value = require('@/assets/imgs/inmobi_default.png');
          hasImage.value = false; // No hay imagen real
        }
        // filteredProperties.value = response.data.resp;
        loader_company.value = false;
      }
    } catch (error) {
      loader_company.value = false;
      console.error("Error fetching data:", error);
    }
  }
  
  async function showToast( type = null, message = null){
    toastAlert.value  = true;
    typeMsg.value     = type;
    msg.value         = message;
  
    setTimeout(() => {
      closeToast();
    }, 3000);
  }
  
  async function closeToast(){
    toastAlert.value = false;
    typeMsg.value    = ''
    msg.value        = '' 
  }
  
  onBeforeMount(async() => {
    loader_company.value = true;
    await getInfoCompany();
  });
  
  watch(
    img_src, // Observa directamente el valor de la referencia
    (newVal) => {
      console.log(newVal.logo);
      if (newVal.logo) {
        // Lógica para cargar datos basados en el nuevo valor
        img_src.value = newVal.logo;
      }
    },
    { immediate: true } // Ejecuta el watch inmediatamente al montar el componente
  );
  </script>
  
  <style scoped>
    .custom-editor .ck-editor__editable {
      min-height: 300px; /* Ajusta a la altura deseada */
      max-height: 600px; /* Opcional: Define un límite máximo */
      overflow: auto; /* Para manejar contenido largo */
    }
  </style>